import React, { useContext, useEffect, useState } from "react";
import { TableContext } from "../index";
import { Pagination } from "./Pagination";

//TODO add page size select
const PAGE_SIZE = 10;

/**
 * Retrieves data from the server and manages pagination.
 * Takes the values from local state instead of URL params.
 * Use only in TableContext scope.
 *
 * @param getPage - pagination request function
 * @param blocked - flag which stops data fetching
 * @param sizeLimit - records limit
 */

export function LocalPaginationManager({ getPage, blocked, sizeLimit = PAGE_SIZE }) {

    const { config, setConfig } = useContext(TableContext);
    const { lastUpdated } = config;

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);

    const onPageChange = (value) => {
        setCurrentPage(value);
    }

    useEffect(() => {

        if (blocked) {
            return;
        }

        // A fallback to set isLoading if the initial state had nothing
        if (!config.devices && !config.users && !config.recipients && !config.isLoading) {
            setConfig({ ...config, isLoading: true });
        }

        getPage(currentPage, sizeLimit).then((data) => {
            setTotalPages(data.totalPages);
            setTotalRecords(data.totalRecords);
            
            // The APIs return varying keys depending on the endpoint (data.devices, data.users, data.recipients)
            const resolvedData = data.devices || data.users || data.recipients || [];

            setConfig({
                ...config,
                // Assign to all possible keys to avoid breaking existing implementations
                devices: data.devices || resolvedData,
                users: data.users || resolvedData,
                recipients: data.recipients || resolvedData,
                pageNumber: data.pageNumber,
                totalPages: data.totalPages,
                selectAll: false,
                selected: [],
                hardReload: false,
                isLoading: false
            })
        }).catch(() => {
            setConfig({ ...config, isLoading: false })
        });
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [lastUpdated, currentPage, blocked])

    return (
        <>
            <Pagination key={totalPages}
                total={totalPages}
                current={currentPage}
                totalRecords={totalRecords}
                onClick={(value) => onPageChange(value)} />
        </>
    )
}

export default LocalPaginationManager;
